import { render, staticRenderFns } from "./selectCircleText.vue?vue&type=template&id=95f30aac&"
import script from "./selectCircleText.vue?vue&type=script&lang=ts&"
export * from "./selectCircleText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports